module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_6005.efd7bc01.png";